module.exports = __webpack_public_path__ + "img/132.6b4d364a.jpg";